<template>
  <div id="main-box" class="page-content" :class="{bottom:list.length > 0}">
    <div class="table-box layui-body" style="left:0;">

      <div class="xblock layui-form">
        <div class="layui-input-inline promote-url">
          <div>返利规则：邀请好友注册exshopee，您将永久享有买家购买上架VIP，40%的现金返佣奖励；</div>
          <div v-if="id && url"><i class="NoSelect">推广链接：</i><i>{{url}}/?id={{id}}</i></div>
          <div v-else>加载中...</div>
        </div>
        <span class="x-right" v-text="'共有数据：'+count+ '条'"></span>
        <span class="x-right" v-text="'总额：'+total+ '分　|　'"></span>
        <div class="clear-both"></div>
      </div>

      <table class="layui-table">
        <thead>
          <tr>
            <th>用户ID</th>
            <th>手机号</th>
            <th>货代积分</th>
            <th>时间</th>
          </tr>
        </thead>
        <tbody>
          <tr class="order_box" v-for="(item,index) in list" v-bind:key="index">
            <td v-text="item.uid"></td>
            <td v-text="item.phone"></td>
            <td v-text="item.money"></td>
            <td v-text="item.created_at"></td>
          </tr>
        </tbody>
      </table>

      <!-- transition -->
      <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

    </div>

    <!-- 分页 -->
    <div class="page-box">
      <div id="pagebox" class="pagebox"></div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

  </div>
</template>

<script>
  var self, form, layer, laypage;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  export default {
    name: 'Promote',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
    },
    data() {
      return {
        id: null,
        url: null,
        isLoding: false,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        page: 1,
        count: 0,
        total: 0,
        page_num: 20,
        current_status: 0,
        status_id: 0,
        list: [],
        data_total: {
          amount_invested: 0,
          escrow_amount: 0,
          total_amount: 0,
          profit: 0,
          profit_margin: 0
        },
        status: [{
          id: 1,
          name: "未完成"
        }, {
          id: 2,
          name: "已完成"
        }]
      }
    },
    mounted() {
      self = this;
      self.SetNavActive("上架", self.$route.name);

      self.url = self.PromoteUrl();

      layui.use(['form', 'layer', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        form.on('select(status_selection)', function(data) {
          var val = $("select[name=status").val() - 1;
          self.current_status = val;
          var status;
          if (val != -1) {
            status = self.status[self.current_status].id;
          } else {
            status = 0;
          }
          self.status_id = status; //获取当前站点
          self.get_recharge_record(true)
        });
        form.render('select');

        self.get_promote_list()
        self.get_user_info();
      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      get_promote_list() {
        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/promote_list/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            if (datas.page) {
              self.list = datas.list;
              self.total = datas.total;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "get_promote_list"); //分页
              $('.pagebox').show();
            } else {
              self.list = [];
              self.count = 0; //页数
              $('.pagebox').hide();
            }
          });

        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      get_user_info() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_user_pcode/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.id = datas;
          });

        }).catch(function(error) {
          console.log(error)
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .promote-url {
    padding-left: 10px;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/Promote.vue